<template>

  <header
    class="flex flex-col items-center justify-center min-h-[calc(100vh-52px)] bg-cover bg-center bg-no-repeat px-4 py-8"
    style="background-color: #020842;">
    <div class="flex flex-col items-center justify-center flex-grow gap-6 md:gap-8 w-full max-w-4xl"
      style="font-family: RockwellNovaLight;">
      <img class="w-full max-w-[280px] sm:max-w-[450px] md:max-w-[600px] lg:max-w-[800px] h-auto object-contain"
        src="@/assets/logo.png" alt="Logo" />

      <h1 class="text-white text-2xl sm:text-3xl md:text-4xl text-center max-w-full px-2 leading-tight tracking-wide">
        SU INSCRIPCION SE COMPLETO EXITOSAMENTE
      </h1>
    </div>
  </header>

</template>
